import { useEffect, useState, useRef } from "react";
import * as toast from "../../../Wrapper/toast/toast";
import * as apiHelper from "../../../Services/ApiHelper";
import * as stringConstants from "../../../Constants/stringConstants";
import { changeDateFormatForServer } from "../../../Utils/dateUtils";
import * as stringUtils from "../../../Utils/stringUtils";
import * as commonServices from "../../../Services/common";
import DiagnosisTypesUI from "./DiagnosisTypeUI";
import { DIAGNOSIS } from "../../../Constants/storageConstant";
const DignosisTypes = () => {
  const [modalShow, setModalShow] = useState(false);
  const [diagnosisList, setDiagnosisList] = useState([]);
  const [dates, setDates] = useState({ startDate: null, endDate: null });
  const [searchQuery, setSearchQuery] = useState("");
  const [lastSelectedPage, setLastSelectedPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [importModal, setImportModal] = useState(false);
  const [importList, setImportList] = useState();
  const [selectedRows, setSelectedRows] = useState([]);

  const datePickerStartRef = useRef();
  const datePickerEndRef = useRef();

  const handleClose = () => {
    setModalShow(false);
    clearData();
  };

  const initialDiagnosisData = {
    name: "",
    description: "",
    action: "Add",
    id: null,
    status: "",
    type_id: null,
  };
  const [addDiagnosisData, setAddDiagnosisData] = useState(initialDiagnosisData);

  useEffect(() => {
    if (
      (dates.startDate !== null && dates.endDate !== null) ||
      (dates.startDate === null && dates.endDate === null)
    ) {
      getDiagnosisList(lastSelectedPage);
    }
  }, [dates]);

  const onPageChange = (page) => {
    getDiagnosisList(page);
  };

  const getDiagnosisList = (page = 1) => {
    const query = `?page=${page}&limit=10&start_date=${changeDateFormatForServer(dates.startDate)}&end_date=${changeDateFormatForServer(dates.endDate)}&q=${searchQuery}`;
    setLoading(true);
    setLastSelectedPage(page);
    apiHelper
      .getDiagnosisList(query)
      .then((response) => {
        if (response?.isSuccess) {
          setDiagnosisList(response?.data);
        } else {
          toast.warn(response?.message);
        }
      })
      .catch((err) => toast.warn(err))
      .finally(() => setLoading(false));
  };

  const clearData = () => {
    setAddDiagnosisData(initialDiagnosisData);
  };

  const validateData = () => {
    const { name } = addDiagnosisData;
    let validData = true;

    if (stringUtils.isNullOrEmpty(name)) {
      toast.warn(stringConstants.NAME_REQUIRED("Diagnosis"));
      validData = false;
    } else if (!stringUtils.isValidName(name)) {
      toast.warn(stringConstants.DIAGNOSIS_NAME_LENGTH);
      validData = false;
    }
    return validData;
  };

  const addDiagnosis = () => {
    if (validateData()) {
      const { name, description, type_id } = addDiagnosisData;
      setButtonLoading(true);
      apiHelper
        .addDiagnosis({ name, description, type_id })
        .then((response) => {
          setButtonLoading(false);
          if (response?.isSuccess) {
            getDiagnosisList(lastSelectedPage);
            commonServices.fetchSystemData();
            toast.success(response.message);
            setModalShow(false);
            clearData();
          } else {
            toast.warn(response?.message);
          }
        })
        .catch((error) => {
          toast.warn(error.message);
        });
    }
  };

  const Action = (data, action = "") => {
    if (action === "edit") {
      setAddDiagnosisData({
        name: data.name,
        description: data.description,
        action: "Edit",
        id: data.id,
      });
      setModalShow(true);
    }
  };

  const editDiagnosis = (id) => {
    if (validateData()) {
      const { name, description, type_id } = addDiagnosisData;
      setButtonLoading(true);
      apiHelper.editDiagnosis(id, { name, description, type_id }).then((response) => {
        setButtonLoading(false);
        if (response?.isSuccess) {
          getDiagnosisList(lastSelectedPage);
          commonServices.fetchSystemData();
          toast.success(response.message);
          setModalShow(false);
          clearData();
        } else {
          toast.warn(response?.message);
        }
      });
    }
  };

  const statusHandler = (data) => {
    const updatedStatus = data.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
    setAddDiagnosisData({ ...addDiagnosisData, status: updatedStatus });
    setButtonLoading(true);

    apiHelper.changeDiagnosisStatus(data.id, { status: updatedStatus }).then((response) => {
      setButtonLoading(false);
      if (response?.isSuccess) {
        getDiagnosisList(lastSelectedPage);
        commonServices.fetchSystemData();
        toast.success(response.message);
        setModalShow(false);
        clearData();
      } else {
        toast.warn(response?.message);
      }
    });
  };

  const importListing = (data) => {
    if (importModal) {
      setLoading(true);
      apiHelper
        .importMaster(DIAGNOSIS, data)
        .then((response) => {
          if (response?.isSuccess) {
            setImportList(response?.data);
          }
        })
        .catch((err) => toast.warn(err))
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const openImportModal = () => {
    setImportModal(true);
  };

  const exportList = () => {
    setButtonLoading(true);
    apiHelper
      .exportMaster(DIAGNOSIS, { ids: selectedRows })
      .then((response) => {
        if (response?.isSuccess) {
          toast.success(response?.message);
          getDiagnosisList(lastSelectedPage);
          commonServices.fetchSystemData(setLoading);
        } else {
          toast.warn(response.message);
        }
      })
      .catch((err) => toast.warn(err))
      .finally(() => {
        setButtonLoading(false);
        setImportModal(false);
      });
  };

  return (
    <DiagnosisTypesUI
      modalShow={modalShow}
      setModalShow={setModalShow}
      handleClose={handleClose}
      diagnosisList={diagnosisList}
      addDiagnosisData={addDiagnosisData}
      setAddDiagnosisData={setAddDiagnosisData}
      dates={dates}
      setDates={setDates}
      datePickerStartRef={datePickerStartRef}
      datePickerEndRef={datePickerEndRef}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      addDiagnosis={addDiagnosis}
      onPageChange={onPageChange}
      editDiagnosis={editDiagnosis}
      loading={loading}
      buttonLoading={buttonLoading}
      Action={Action}
      showConfirmModal={showConfirmModal}
      setShowConfirmModal={setShowConfirmModal}
      getDiagnosisList={getDiagnosisList}
      statusHandler={statusHandler}
      importListing={importListing}
      exportList={exportList}
      importModal={importModal}
      importList={importList}
      selectedRows={selectedRows}
      setSelectedRows={setSelectedRows}
      setImportModal={setImportModal}
      openImportModal={openImportModal}
    />
  );
};

export default DignosisTypes;
